var $ = require('jquery');

exports.init = function() {

    /* when modules open, add the insert image button to their toolbar */
    $(document).bind('diy-editor-module-opened-for-editing', function(ev, data) {
        var module = data.module;

        /* only add button to the toolbar for Gallery, Image and Image with Text modules */
        if (['gallery'].indexOf(module.getModuleType()) === -1) {
            return;
        }
        var buttonLabel, iconCls;
        switch (module.moduleType) {
            case 'gallery':
                buttonLabel = jimdoData.messages.filemanager.openFromGalleryModule;
                iconCls = 'add-images';
                break;
        }

        /* create button template */
        var fileManagerTpl = '\
            <div class="mod-bar-primary-sep" style="display: block"></div>\
            <div class="mod-bar-primary-section mod-fm-insert-image" id="mod-fm-insert-image_' + module.moduleId + '">\
            <div class="mod-bar-primary-section-title">' + buttonLabel +'</div>\
            <div class="mod-bar-primary-section-content">\
            <a onclick="mm[' + module.moduleId + '].startFileManager();"\
                class="ui-icon-24 ' + iconCls + ' mod-bar-secondary-section-tab"></a>\
            </div></div>';

        var $configEl = module.getEditorContainer();

        /* append template to module's toolbar */
        if (!$configEl.find('.mod-fm-insert-image').length) {

            if ('gallery' == module.moduleType) {
                $configEl.find('.mod-bar-primary-section:last').after(fileManagerTpl);
            }
        }
    });
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/integration/fmModul.js
 ** module id = 984
 ** module chunks = 0
 **/